// Single source of truth for "what date represents this feature's most
// recent activity" — used both to SORT the list and to DISPLAY a date on
// the card, so the two always agree. Without this, a card could show
// created_at while the list is ordered by updated_at, making the order
// look "wrong" even when it's sorting correctly by a different field.

// Returns a valid Date for `updated_at`, or falls back to `created_at` only
// when `updated_at` is missing/null/an unparseable value.
export const getEffectiveDate = (feature) => {
  const updated = feature?.updated_at ? new Date(feature.updated_at) : null;
  if (updated && !isNaN(updated.getTime())) return updated;

  const created = feature?.created_at ? new Date(feature.created_at) : null;
  if (created && !isNaN(created.getTime())) return created;

  return null; // No usable date at all — caller decides how to handle this.
};

// Numeric timestamp for sorting; missing/invalid dates sort to the very
// end (oldest) rather than accidentally floating to the top as "newest".
export const getEffectiveTime = (feature) => {
  const date = getEffectiveDate(feature);
  return date ? date.getTime() : -Infinity;
};
